import type { Product } from '@/lib/api.types'

const EMPTY_HTML_TAG_PATTERN = /<([a-z][a-z0-9]*)\b[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/\1>/gi

const asObject = (value: unknown) =>
  value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : null

const normalizeText = (value: unknown) => {
  if (typeof value !== 'string') {
    return ''
  }

  return value
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const getProductDescription = (product: Product) => normalizeText(product.description)

const normalizeRichText = (value: unknown) => {
  if (typeof value !== 'string') {
    return ''
  }

  let normalizedValue = value.trim()
  let nextValue = normalizedValue

  // Remove wrappers that contain only line breaks/whitespace (e.g. <h3><br></h3>).
  do {
    normalizedValue = nextValue
    nextValue = normalizedValue.replace(EMPTY_HTML_TAG_PATTERN, '').trim()
  } while (nextValue !== normalizedValue)

  return normalizedValue
}

export const getProductFullDescription = (product: Product) => {
  const normalizedFullDescription = normalizeRichText(product.fullDescription)
  if (normalizedFullDescription.length > 0) {
    return normalizedFullDescription
  }

  return null
}

export const getProductDurationMinutes = (product: Product): number | null => {
  const productSettings = asObject((product as unknown as Record<string, unknown>).settings)
  const durationMinutes = Number(productSettings?.durationInMinutes)

  if (!Number.isFinite(durationMinutes) || durationMinutes <= 0) {
    return null
  }

  return Math.floor(durationMinutes)
}
